import React from 'react';
import PropTypes from 'prop-types';
import {
  TextField,
  IconButton,
  InputAdornment,
} from '@mui/material';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { speakWithOpenAI } from './speakWithOpenAI';

export default function PronunciationField(props) {
  const { hideIcon = false } = props.options ?? {};
  const {
    id,
    value = '',
    required,
    disabled,
    readonly,
    onChange,
    formContext,
    schema,
  } = props;

  const firstName = formContext?.formData?.first_name ?? '';
  const firstPron = formContext?.formData?.first_name_pronunciation ?? '';
  const textToSpeak = (value || firstPron || firstName).trim();

  const play = () => {
    if (!textToSpeak) return;
    speakWithOpenAI(textToSpeak);
  };

  return (
    <TextField
    id={id}
    fullWidth
    label={schema?.title}
    value={value}
    required={required}
    disabled={disabled || readonly}
    onChange={(e) => onChange(e.target.value)}
    variant='outlined'                /* or keep variant you use elsewhere */
    InputLabelProps={{ shrink: Boolean(value) }}
    InputProps={{
        endAdornment: hideIcon ? null  : (
        <InputAdornment position='end' sx={{ mr: -6 }}>
            <IconButton
            edge='end'
            size='small'
            aria-label='play pronunciation'
            onClick={play}
            disabled={disabled || readonly || !textToSpeak}
            >
            <VolumeUpIcon fontSize='small' />
            </IconButton>
        </InputAdornment>
        ),

        sx: {
        height: 60,                          // overall height
        '& .MuiInputBase-input': {
            display      : 'flex',             // let the line-box fill height
            
            height       : '100%',
            paddingTop   : 0,                  // remove default 8 px
            paddingBottom: 0,                  // remove default 8 px
            paddingLeft  : 2,                 // keep horizontal paddings
            paddingRight : 2,
        },
        },
    }}
    sx={{ mt: 2 }}
    />  
  );
}

PronunciationField.propTypes = {
  id         : PropTypes.string,
  value      : PropTypes.string,
  required   : PropTypes.bool,
  disabled   : PropTypes.bool,
  readonly   : PropTypes.bool,
  options   : PropTypes.object,
  onChange   : PropTypes.func.isRequired,
  formContext: PropTypes.object,
  schema     : PropTypes.object.isRequired,
};